<template>
  <div class="col-md-12">
    <div class="card card-container">
      <v-img
          id="profile-img"
          src="@/assets/merkur.png"
          class="profile-img-card"
      />
      <Form @submit="handleLogin" :validation-schema="schema" autocomplete="off">
        <div class="form-group">
          <div class="d-flex">
            <label for="personalnummer">Benutzername</label>
            <v-tooltip text="Ihre Personalnummer (z.B. gXXXXXX). Falls Sie diese bei der Registrierung nicht angeben mussten, ist Ihre E-Mail Adresse der Benutzername"
                       v-model="showTooltipUserName"
            >
              <template v-slot:activator="{ props }">
                <v-icon v-bind="props"
                        icon="mdi-information-slab-circle-outline"
                        size="30"
                        class="mt-1 ml-3"
                        @click="showTooltipUserName = !showTooltipUserName"
                />
              </template>
            </v-tooltip>
          </div>
          <Field id="personalnummer" name="personalnummer" type="text" class="form-control" autocomplete="off"/>
          <ErrorMessage name="personalnummer" class="error-feedback" style="color: red"/>
        </div>
        <div class="form-group">
          <label for="password">Passwort</label>
          <Field name="password" type="password" class="form-control" autocomplete="off"/>
          <ErrorMessage name="password" class="error-feedback" style="color: red"/>
        </div>

        <div class="form-group">
          <button class="btn btn-primary btn-block" :disabled="loading">
            <span
                v-show="loading"
                class="spinner-border spinner-border-sm"
            ></span>
            <span>Anmelden</span>
          </button>
        </div>

        <div class="form-group">
          <div v-if="message" class="alert alert-danger" role="alert">
            {{ message }}
          </div>
        </div>
      </Form>
      <label @click="() => TogglePopup('resetPWD')">Passwort vergessen?</label>
    </div>
  </div>
  <ResetPWD v-if="popupTriggers.resetPWD"
            :TogglePopup="() => TogglePopup('resetPWD')"></ResetPWD>
</template>

<script>
import {ErrorMessage, Field, Form} from "vee-validate";
import * as yup from "yup";
import ResetPWD from "@/components/ResetPWD";
import {ref} from "vue";

export default {
  name: "login-view",
  components: {
    Form,
    Field,
    ErrorMessage,
    ResetPWD,
  },
  setup() {
    const popupTriggers = ref({
      resetPWD: false,
    });

    const TogglePopup = (trigger) => {
      popupTriggers.value[trigger] = !popupTriggers.value[trigger]
    }

    return {
      popupTriggers,
      TogglePopup
    }
  },
  watch:{
    "schema.password": function(){
      console.log(this.schema.password);
    }
  },
  data() {
    const schema = yup.object().shape({
      personalnummer: yup.string().required("Bitte geben Sie Ihren Benutzernamen ein!"),
      password: yup.string().required("Bitte geben sie Ihr Passwort ein!"),
    });

    return {
      loading: false,
      message: "",
      schema,
      showTooltipUserName: false,
    };
  },
  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    },
    currentUser() {
      return this.$store.state.auth.user;
    }
  },
  methods: {
    handleLogin(user) {
      this.loading = true;

      if(user.password.includes("invalidPWD")){
        this.loading = false;
      }else{
        this.$store.dispatch("auth/login", user).then(
            () => {
              this.$router.push("/");
            },
            (error) => {
              this.loading = false;
              let msg = error.response &&
                  error.response.data &&
                  error.response.data.message ||
                  error.message ||
                  error.toString()
              console.log(msg);
              if(msg === "Bad credentials"){
                this.message = "Falsche Anmeldedaten!"
              }
              else{
                this.message = msg;
              }
            }
        );
      }
    },
  },
};
</script>

<style scoped>
label {
  display: block;
  margin-top: 10px;
}

.card-container.card {
  max-width: 350px !important;
  padding: 40px 40px;
}

.card {
  background-color: #f7f7f7;
  padding: 20px 25px 30px;
  margin: 0 auto 25px;
  margin-top: 50px;
  -moz-border-radius: 2px;
  -webkit-border-radius: 2px;
  border-radius: 2px;
  -moz-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
}

.profile-img-card {
  width: 96px;
  height: 96px;
  margin: 0 auto 10px;
  display: block;
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
  border-radius: 50%;
}
</style>
